import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=3b3cf06b&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=3b3cf06b&prod&lang=scss&scoped=true"
import style1 from "./UserLayout.vue?vue&type=style&index=1&id=3b3cf06b&prod&lang=scss"
import style2 from "./UserLayout.vue?vue&type=style&index=2&id=3b3cf06b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3cf06b",
  null
  
)

export default component.exports